var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.188 10.5c0 .669-.543 1.211-1.211 1.211h-4.18L10 8.078l1.94-3.36a1.21 1.21 0 0 1 2.098 1.211l-1.94 3.36h3.879c.668 0 1.21.542 1.21 1.211z",
    fill: "#1A73E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.59 16.725c-.58.334-1.32.136-1.654-.444l-1.94-3.359-1.94 3.36a1.211 1.211 0 0 1-2.098-1.211l1.94-3.36 2.098-.078 2.098.078 1.94 3.36c.334.579.135 1.32-.444 1.654z",
    fill: "#EA4335"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.996 8.078 9.45 9.563l-1.551-.274-1.94-3.36a1.21 1.21 0 0 1 2.098-1.211l1.94 3.36z",
    fill: "#FBBC04"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.688 9.29 8.28 11.71H4.023a1.21 1.21 0 1 1 0-2.42h5.665z",
    fill: "#34A853"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.094 11.711H7.898l2.098-3.633 2.098 3.633z",
    fill: "#185DB7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.45e8e785d4b8997f12786b7d9b2973cb.svg";
export { ForwardRef as ReactComponent };